var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "h2",
    {
      ref: "previewText",
      staticClass: "tf-proc",
      attrs: { "data-h": _vm.groupHeight },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }